/**
 * Engagement states for a customer user's activity
 */
export enum EngagementState {
  NONE = 'none',           // Red - no engagement
  LOGIN = 'login',         // Yellow - user logged in
  ACTIVITY = 'activity',   // Green - task activity (edit/add/complete)
  ENGAGED = 'engaged',     // Star - has both task activity and comment activity
  UNKNOWN = 'unknown'      // Gray - no data available for this day
}

/**
 * Engagement data for a specific date
 */
export interface DailyEngagement {
  date: string;           // ISO date string (YYYY-MM-DD)
  state: EngagementState;
  hasLogin: boolean;
  hasTaskActivity: boolean;
  hasCommentActivity: boolean;
}

/**
 * Engagement metrics for a customer user
 */
export interface CustomerEngagement {
  customerId: string;
  customerUserId: string;
  projectId: string;
  lastUpdated: string;    // ISO timestamp
  days: DailyEngagement[];
}
